module.exports = __webpack_public_path__ + "static/media/barChartInactive.c35569fd.svg";